import type { FC } from 'react';
import { SimpleGrid, Skeleton } from '@chakra-ui/react';

const skeletonItems = Array.from({ length: 12 }, (_, index) => `skeleton-${index}`);

export const SearchSkeletons: FC = () => (
    <div className="mb-16 mt-2 gap-8 px-0 sm:px-8 lg:px-10 xl:px-16" data-testid="search-skeleton">
        <div className="flex flex-col gap-4 overflow-visible md:overflow-hidden">
            <div className="flex flex-col gap-1">
                <Skeleton height="30px" width="118px" borderRadius="0" />
                <Skeleton height="22px" width="242px" borderRadius="0" />
            </div>
            <Skeleton height="26px" width="960px" borderRadius="0" />
            <Skeleton height="30px" width="564px" borderRadius="0" />
        </div>
        <SimpleGrid
            columns={{ base: 2, sm: 3, md: 4 }}
            columnGap={{ base: 3, sm: 6 }}
            rowGap={8}
            mt={{ base: 6, md: 8 }}
            alignItems="stretch"
        >
            {skeletonItems.map((id) => (
                <Skeleton
                    key={id}
                    height={{ base: '392px', sm: '427px', md: '456px', lg: '573px', xl: '612px' }}
                />
            ))}
        </SimpleGrid>
        <div className="mt-8 flex flex-col items-center gap-3">
            <Skeleton height="24px" width="134px" borderRadius="0" />
            <Skeleton height="40px" width="174px" borderRadius="0" />
        </div>
    </div>
);
